import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { handleRequestError } from 'Shared/utils/handle-request-error';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';
import FeedbackCommentSchema from 'Shared/utils/normalizeJSON/schemas/FeedbackComment.schema';
import FeedbackCommentsConstants from 'Shared/constants/FeedbackComments.constants';
import { getFeedbackCommentByUuid } from 'Shared/selectors/FeedbackComments.selectors';
import * as api from 'Shared/api/FeedbackComments.api';

export const createFeedbackCommentRequest = payload => ({
  type: FeedbackCommentsConstants.Actions.CREATE_FEEDBACK_COMMENT_REQUEST,
  payload,
});

export const createFeedbackCommentSuccess = payload => ({
  type: FeedbackCommentsConstants.Actions.CREATE_FEEDBACK_COMMENT_SUCCESS,
  payload,
});

export const createFeedbackCommentFailure = payload => ({
  type: FeedbackCommentsConstants.Actions.CREATE_FEEDBACK_COMMENT_FAILURE,
  payload,
});

export const updateFeedbackCommentRequest = payload => ({
  type: FeedbackCommentsConstants.Actions.UPDATE_FEEDBACK_COMMENT_REQUEST,
  payload,
});

export const updateFeedbackCommentSuccess = payload => ({
  type: FeedbackCommentsConstants.Actions.UPDATE_FEEDBACK_COMMENT_SUCCESS,
  payload,
});

export const updateFeedbackCommentFailure = payload => ({
  type: FeedbackCommentsConstants.Actions.UPDATE_FEEDBACK_COMMENT_FAILURE,
  payload,
});

export const destroyFeedbackCommentRequest = payload => ({
  type: FeedbackCommentsConstants.Actions.DESTROY_FEEDBACK_COMMENT_REQUEST,
  payload,
});

export const destroyFeedbackCommentFailure = payload => ({
  type: FeedbackCommentsConstants.Actions.DESTROY_FEEDBACK_COMMENT_FAILURE,
  payload,
});

export const viewFeedbackCommentSuccess = payload => ({
  type: FeedbackCommentsConstants.Actions.VIEW_FEEDBACK_COMMENT_SUCCESS,
  payload,
});

export const createFeedbackComment = comment => async dispatch => {
  dispatch(createFeedbackCommentRequest(comment));
  return handleRequestError(api.createFeedbackComment(comment))
    .then(response => {
      dispatch(createFeedbackCommentSuccess(normalizer(FeedbackCommentSchema, response.data)));
      WpToastManager.success('Comment created');
    })
    .catch(e => {
      // TODO: (josh) : this delete of the optimistic create does not work
      dispatch(createFeedbackCommentFailure(comment.uuid));
      WpToastManager.danger(e.message);
    });
};

export const updateFeedbackComment = data => async (dispatch, getState) => {
  const comment = getFeedbackCommentByUuid(data.uuid)(getState());
  dispatch(updateFeedbackCommentRequest(data));
  return handleRequestError(api.updateFeedbackComment(data))
    .then(response => {
      dispatch(updateFeedbackCommentSuccess(normalizer(FeedbackCommentSchema, response.data)));
      WpToastManager.success('Comment updated');
    })
    .catch(e => {
      dispatch(updateFeedbackCommentFailure(comment));
      WpToastManager.danger(e.message);
    });
};

export const destroyFeedbackComment = uuid => async (dispatch, getState) => {
  const comment = getFeedbackCommentByUuid(uuid)(getState());
  dispatch(destroyFeedbackCommentRequest(uuid));
  return handleRequestError(api.destroyFeedbackComment(uuid)).catch(e => {
    dispatch(destroyFeedbackCommentFailure(comment));
    WpToastManager.danger(e.message);
  });
};

export const viewFeedbackComment = uuid => async dispatch => {
  return handleRequestError(api.viewFeedbackComment(uuid)).then(response =>
    dispatch(viewFeedbackCommentSuccess(normalizer(FeedbackCommentSchema, response.data)))
  );
};
